<script>
import moment from 'moment';
import Modal from './Modal.vue';

export default {
  props: [
    'epiDivClass',
    'title',
    'linkTextEvents',
    'linkTextSubscribe',
    'eventSettings',
    'modalSettings',
  ],
  components: {
    Modal,
  },
  data() {
    return {
      url: '',
      loading: false,
      items: [],
      events: [],
      showModal: false,
      news: [],
      IsInit: true,
      PageIndex: 0,
      hideImage: this.eventSettings?.HideImage,
      maxItems: this.eventSettings?.PageSize || 20,
    };
  },
  async created() {
    await import(
      /* webpackChunkName: "forms" */ '../../../static/js/loaders/forms.js'
    );
  },
  mounted() {
    //if (document.getElementById('calendarblock')) {
    this.waitForUrlBeforeFetch();
    //}
  },
  methods: {
    isLoading(bool) {
      this.loading = bool;
    },
    requestData() {
      return {
        CalendarPageId: this.eventSettings?.CalendarPageId || '',
        PageSize: this.eventSettings?.PageSize || 20,
        City: this.eventSettings?.DefaultCity || '',
        PageIndex: this.PageIndex,
        LanguageId: this.eventSettings?.LanguageId || 'sv',
      };
    },
    fetchMore() {
      if (this.PageIndex < this.items.PageCount) {
        this.PageIndex += 1;
        this.fetchData(this.url, this.requestData());
      } else {
        this.error = true;
        this.errorText = 'Det finns inga fler evenemang.';
      }
    },
    async waitForUrlBeforeFetch() {
      if (this.eventSettings?.urlToService) {
        await this.fetchEvents(
          this.eventSettings?.urlToService,
          this.requestData()
        );
      }
      this.formatDateAndFilterByDate(this.events);
    },
    async formatDateAndFilterByDate(arr) {
      if (arr) {
        try {
          arr.forEach((element) => {
            let isMultipleDays = this.checkEventDates(element);
            element.isMultipleDays = isMultipleDays;
            if (isMultipleDays) {
              element.captionDate = `${moment(element.StartDate)
                .locale('sv')
                .format('D MMMM')} - ${moment(element.StopDate)
                .locale('sv')
                .format('D MMMM')}`;

              element.datesAndYear = `${moment(element.StartDate)
                .locale('sv')
                .format('D MMMM')} - ${moment(element.StopDate)
                .locale('sv')
                .format('D MMMM YYYY')}`;
            }

            element.StartDate = moment(element.StartDate)
              .locale('sv')
              .format('LL');

            element.ChangedDate = moment(element.ChangedDate)
              .locale('sv')
              .format('LL');
          });
          arr.sort(
            (a, b) =>
              moment(a.StartDate).toDate() - moment(b.StartDate).toDate()
          );
          this.items = arr;
          this.isLoading(false);
        } catch (error) {
          this.isLoading(false);
        }
      }
    },
    async fetchEvents(url, req) {
      try {
        let response = await fetch(url, {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(req),
        });
        let data = await response.json();

        if (data) {
          this.events = data.Events;
        } else {
          this.events = data.Events;
        }
      } catch (error) {
        this.isLoading(false);
      }
    },
    checkEventDates(event) {
      let startDate = new Date(event.StartDate);
      let stopDate = new Date(event.StopDate);

      startDate.setHours(0, 0, 0, 0);
      stopDate.setHours(0, 0, 0, 0);

      if (stopDate.getTime() > startDate.getTime()) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<template>
  <div class="calendar-block" v-cloak>
    <div class="block-header">
      <div>
        <h2 class="heading-level-2 mr-auto">{{ title.value }}</h2>
        <div class="d-block d-sm-none pb-md"></div>
        <div class="block-action d-flex align-items-center">
          <a id="show-modal" @click.prevent="showModal = true" href="#">{{
            linkTextSubscribe.value
          }}</a>
        </div>
      </div>
    </div>
    <div class="row">
      <template v-if="!loading">
        <div class="col-12" v-for="(item, index) in items" :key="index">
          <article v-if="index <= maxItems" role="article">
            <a
              href="#"
              v-if="!hideImage"
              class="d-flex"
              :class="{ 'article--image': item.ImageData }"
              :style="`background-image: url(${item.ImageData})`">
              <div class="caption mt-auto">
                {{ item.StartDate }}
              </div>
            </a>
            <a href="#" v-else class="d-flex">
              <div class="caption mt-auto">
                <template v-if="item.isMultipleDays">
                  {{ item.captionDate }}
                </template>
                <template v-else>
                  {{ item.StartDate }}
                </template>
              </div>
            </a>
            <h2 class="heading-level-3">
              <a :href="item.Url">{{ item.Title }}</a>
            </h2>
            <p v-if="item.Intro">{{ item.Intro }}</p>
            <div
              class="d-flex flex-row align-items-center flex-wrap event--info"
              v-if="eventSettings.CalendarPageId">
              <p
                class="mb-0 mr-3"
                v-if="item.StartDate && !item.isMultipleDays">
                {{ item.StartDate }}&nbsp
              </p>
              <p
                class="mb-0 mr-3"
                v-if="item.StartTime && !item.isMultipleDays">
                {{ item.StartTime }}–{{ item.StopTime }}&nbsp
              </p>
              <p class="mb-0 mr-3" v-if="item.isMultipleDays">
                {{ item.datesAndYear }}&nbsp
              </p>
              <p class="mb-0" v-if="item.City">
                {{ item.City }}<span v-if="item.Location">, &nbsp</span>
              </p>
              <p class="mb-0" v-if="item.Location">{{ item.Location }}</p>
            </div>
          </article>
        </div>
      </template>
      <div class="col-12" v-for="i in 6" :key="i" v-if="loading">
        <article class="fake--article">
          <div class="fake--image loading"></div>
          <div class="fake--title loading mt-xs mb-xs"></div>
          <div class="fake--text mb-xs">
            <div class="loading"></div>
            <div class="loading"></div>
            <div class="loading"></div>
          </div>
        </article>
      </div>
    </div>
  </div>
  <Modal v-if="showModal" @close="showModal = false" v-cloak>
    <template v-slot:header>
      <h3>{{ modalSettings.title }}</h3>
    </template>
    <template v-slot:body>
      <div class="row mb-xs">
        <div class="col-3 col-md-1">
          <img
            src="/Static/images/onepixel.png"
            :data-src="modalSettings.windows.iconUrl"
            alt="windows icon"
            class="img-fluid lazyload" />
          <div class="d-block d-sm-none mb-xs"></div>
        </div>
        <div class="col-12 col-md-11">
          <p v-html="modalSettings.windows.text"></p>
          <a
            v-if="modalSettings.windows.urlToService"
            :href="modalSettings.windows.urlToService"
            >{{ modalSettings.windows.urlText }}</a
          >
        </div>
      </div>
      <div class="row mb-xs">
        <div class="col-3 col-md-1">
          <img
            src="/Static/images/onepixel.png"
            :data-src="modalSettings.apple.iconUrl"
            alt="apple icon"
            class="img-fluid lazyload" />
          <div class="d-block d-sm-none mb-xs"></div>
        </div>
        <div class="col-12 col-md-11">
          <p v-html="modalSettings.apple.text"></p>
          <a
            v-if="modalSettings.apple.urlToService"
            :href="modalSettings.apple.urlToService"
            >{{ modalSettings.apple.urlText }}</a
          >
        </div>
      </div>
      <div class="row mb-xs">
        <div class="col-3 col-md-1">
          <img
            src="/Static/images/onepixel.png"
            :data-src="modalSettings.android.iconUrl"
            alt="android icon"
            class="img-fluid lazyload" />
          <div class="d-block d-sm-none mb-xs"></div>
        </div>
        <div class="col-12 col-md-11">
          <p v-html="modalSettings.android.text"></p>
          <a
            v-if="modalSettings.android.urlToService"
            :href="modalSettings.android.urlToService"
            >{{ modalSettings.android.urlText }}</a
          >
          <div class="d-block d-sm-none mb-md"></div>
        </div>
      </div>
    </template>
  </Modal>
</template>
